var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "metric-card" },
    [
      _c("el-col", { staticClass: "icon-col", attrs: { span: 6 } }, [
        _c("i", { class: _vm.icon, style: { color: _vm.color } })
      ]),
      _c(
        "el-col",
        { staticClass: "text-col", attrs: { span: 18 } },
        [
          _c("el-row", [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t(_vm.label)))
            ])
          ]),
          _c("el-row", [
            _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.value))])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }